<template>
    <a-modal :open="visible" title="检测到未保存的内容" :width="500" :closable="false" :maskClosable="false" @ok="handleRecover"
        @cancel="handleIgnore" ok-text="恢复内容" cancel-text="忽略并继续">

        <div class="recovery-content">
            <div class="warning-icon">
                <ExclamationCircleOutlined style="color: #faad14; font-size: 24px;" />
            </div>

            <div class="recovery-info">
                <p class="main-message">
                    检测到您有未保存的{{ draftType === 'create' ? '新文章' : '文章修改' }}内容
                </p>

                <div class="cache-details">
                    <div class="detail-item">
                        <span class="label">上次编辑时间：</span>
                        <span class="value">{{ formattedTime }}</span>
                    </div>

                    <div class="detail-item" v-if="cacheData && cacheData.title">
                        <span class="label">文章标题：</span>
                        <span class="value">{{ cacheData.title }}</span>
                    </div>

                    <div class="detail-item" v-if="contentPreview">
                        <span class="label">内容预览：</span>
                        <span class="value content-preview">{{ contentPreview }}</span>
                    </div>
                </div>

                <div class="recovery-actions">
                    <p class="action-hint">
                        选择"恢复内容"将加载您之前的编辑内容，选择"忽略并继续"将丢弃未保存的内容。
                    </p>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

export default {
    name: 'DraftRecoveryModal',
    components: {
        ExclamationCircleOutlined
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        cacheData: {
            type: Object,
            default: () => ({})
        },
        draftType: {
            type: String,
            default: 'create' // 'create' or 'edit'
        }
    },
    emits: ['recover', 'ignore'],
    computed: {
        formattedTime() {
            if (!this.cacheData || !this.cacheData.lastModified) {
                return '未知时间'
            }

            const date = new Date(this.cacheData.lastModified)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        },

        contentPreview() {
            if (!this.cacheData || !this.cacheData.content) {
                return ''
            }

            // 移除HTML标签，获取纯文本
            const textContent = this.cacheData.content.replace(/<[^>]*>/g, '').trim()

            // 截取前50个字符
            return textContent.length > 50
                ? textContent.substring(0, 50) + '...'
                : textContent
        }
    },
    methods: {
        handleRecover() {
            this.$emit('recover', this.cacheData)
        },

        handleIgnore() {
            this.$emit('ignore')
        }
    }
}
</script>

<style scoped>
.recovery-content {
    display: flex;
    gap: 16px;
    padding: 8px 0;
}

.warning-icon {
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    padding-top: 2px;
}

.recovery-info {
    flex: 1;
}

.main-message {
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    margin: 0 0 16px 0;
    line-height: 1.4;
}

.cache-details {
    background: #fafafa;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 16px;
}

.detail-item {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
}

.detail-item:last-child {
    margin-bottom: 0;
}

.label {
    font-weight: 500;
    color: #595959;
    min-width: 100px;
    flex-shrink: 0;
}

.value {
    color: #262626;
    flex: 1;
    word-break: break-word;
}

.content-preview {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: #595959;
    background: white;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
}

.recovery-actions {
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
}

.action-hint {
    font-size: 14px;
    color: #8c8c8c;
    margin: 0;
    line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .recovery-content {
        flex-direction: column;
        gap: 12px;
    }

    .warning-icon {
        align-self: center;
    }

    .detail-item {
        flex-direction: column;
        gap: 4px;
    }

    .label {
        min-width: auto;
    }
}
</style>